"use strict";
const lib = require("./index");
const ua_parser_js_1 = require("ua-parser-js");
const engine = new ua_parser_js_1.UAParser().getEngine().name;
if (engine !== undefined && !/WebKit/i.test(engine)) {
    if (!Array.prototype.qMapMany) {
        Array.prototype.qMapMany = function (selector) { return lib.mapManyNative(this, selector); };
    }
    if (!Array.prototype.qSelect) {
        Array.prototype.qSelect = Array.prototype.map;
    }
}
if (!Array.prototype.qContains) {
    Array.prototype.qContains = function (right, comparer) {
        return lib.contains(this, right, comparer);
    };
}
if (!Array.prototype.qIntersect) {
    Array.prototype.qIntersect = function (right, comparer) {
        return lib.intersect(this, right, comparer);
    };
}
if (!Array.prototype.qSame) {
    Array.prototype.qSame = function (right, comparer) {
        return lib.same(this, right, comparer);
    };
}
if (!Array.prototype.qEmpty) {
    Array.prototype.qEmpty = function () {
        return lib.empty(this);
    };
}
if (!Array.prototype.qFirst) {
    Array.prototype.qFirst = function (predicate) {
        return lib.first(this, predicate);
    };
}
if (!Array.prototype.qLast) {
    Array.prototype.qLast = function (predicate) {
        return lib.last(this, predicate);
    };
}
if (!Array.prototype.qRotate) {
    Array.prototype.qRotate = function (offset) {
        return lib.rotate(this, offset);
    };
}
if (!Array.prototype.qMapMany) {
    Array.prototype.qMapMany = function (selector) {
        return lib.mapMany(this, selector);
    };
}
if (!Array.prototype.qDistinct) {
    Array.prototype.qDistinct = function (key) {
        return lib.distinct(this, key);
    };
}
if (!Array.prototype.qSelect) {
    Array.prototype.qSelect = function (predicate) {
        return lib.select(this, predicate);
    };
}
if (!Array.prototype.qAny) {
    Array.prototype.qAny = function (predicate) {
        return lib.any(this, predicate);
    };
}
if (!Array.prototype.qAll) {
    Array.prototype.qAll = function (predicate) {
        return lib.all(this, predicate);
    };
}
if (!Array.prototype.qIncludes) {
    Array.prototype.qIncludes = function (value) {
        return lib.includes(this, value);
    };
}
if (!Array.prototype.qNone) {
    Array.prototype.qNone = function (predicate) {
        return lib.none(this, predicate);
    };
}
if (!Array.prototype.qCount) {
    Array.prototype.qCount = function (predicate) {
        return lib.count(this, predicate);
    };
}
if (!Array.prototype.qWhere) {
    Array.prototype.qWhere = function (predicate) {
        return lib.where(this, predicate);
    };
}
//# sourceMappingURL=prototype.js.map


// WEBPACK FOOTER //
// ./node_modules/arrayq/es6/prototype.js